export function radar_historie(type, title, unit) {

    $(function () {

        let selector = $('#'+type)

        let points = selector.attr('data-points').split(",").map(x => Number(x))
        let year = selector.attr('data-year')

        // 2013 erst ab September anzeigen
        let month = 0
        let day = 1
        let hour = 0

        if (year == '2013') {
          month = 8
          day = 13
          hour = 9
        }


        Highcharts.setOptions({
            lang: {
                resetZoom: 'Zoom zurücksetzen',
                shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                weekdays: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.']
            }
        });

        Highcharts.chart(type, {

            colors: ['#95DA3B', '#bbbbbb', '#4D759E'],
            chart: {
                zoomType: 'x',
                type: 'line',
                marginRight: 20,
                marginBottom: 25
            },
            title: {
                text: 'Historie Energieradar ' + title,
                x: -40 //center
            },
            subtitle: {
                text: 'Mit der Maus können Sie sich einen Zeitraum näher anzeigen lassen.',
                x: -40 //center
            },
            xAxis: {
                type: 'datetime',
                maxZoom: 900000 * 2, // 30 Minuten
                title: {
                    text: null
                }
            },
            yAxis: {
                title: {
                    text: unit
                },
                plotLines: [{
                    value: 0,
                    width: 1,
                    color: '#808080'
                }]
            },
            tooltip: {
                valueSuffix: unit

            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -10,
                y: -10,
                borderWidth: 0
            },

            plotOptions: {
                line: {
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 2
                        }
                    },
                    marker: {
                        enabled: false
                    }
                }
            },
            series: [
                {
                    name: 'Netzeinspeisung',
                    pointInterval: 3600000, // stündlich
                    pointStart: Date.UTC(year, month, day, hour, 0),
                    data: points
                }
            ]

        });
    });

}


export function radar_historie_power(title, unit) {

    $(function () {

        let type = 'power'
        let selector = $('#'+type)

        let points_coverage = selector.attr('data-points-coverage').split(",").map(x => Number(x))
        let points_regional = selector.attr('data-points-regional').split(",").map(x => Number(x))
        let points_import = selector.attr('data-points-import').split(",").map(x => Number(x))
        let year = selector.attr('data-year')

        // 2013 erst ab September anzeigen
        let month = 0
        let day = 1
        let hour = 0

        if (year === '2013') {
            month = 8
            day = 13
            hour = 9
        }


        Highcharts.setOptions({
            lang: {
                resetZoom: 'Zoom zurücksetzen',
                shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                weekdays: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.']
            }
        });

        Highcharts.chart(type, {

            colors: ['#95DA3B', '#bbbbbb', '#4D759E'],
            chart: {
                zoomType: 'x',
                type: 'line',
                marginRight: 20,
                marginBottom: 25
            },
            title: {
                text: 'Historie Energieradar ' + title,
                x: -40 //center
            },
            subtitle: {
                text: '',
                x: -40 //center
            },
            xAxis: {
                type: 'datetime',
                maxZoom: 900000 * 2, // 30 Minuten
                title: {
                    text: null
                }
            },
            yAxis: {
                title: {
                    text: unit
                },
                plotLines: [{
                    value: 0,
                    width: 1,
                    color: '#808080'
                }]
            },
            tooltip: {
                valueSuffix: unit

            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -10,
                y: -10,
                borderWidth: 0
            },

            plotOptions: {
                line: {
                    lineWidth: 2,
                    states: {
                        hover: {
                            lineWidth: 2
                        }
                    },
                    marker: {
                        enabled: false
                    }
                }
            },
            series: [
                {
                    name: 'Verbrauch',
                    pointInterval: 3600000, // stündlich
                    pointStart: Date.UTC(year, month, day, hour, 0),
                    data: points_coverage
                },
                {
                    name: 'lokale Erzeugung',
                    pointInterval: 3600000, // stündlich
                    pointStart: Date.UTC(year, month, day, hour, 0),
                    data: points_regional
                },
                {
                    name: 'Import (+) / Export (-)',
                    pointInterval: 3600000, // stündlich
                    pointStart: Date.UTC(year, month, day, hour, 0),
                    data: points_import
                }
            ]

        });
    });

}